import {
  FETCH_LEAVE_ADJUSTMENTS_REQUEST, FETCH_LEAVE_ADJUSTMENTS_SUCCESS, FETCH_LEAVE_ADJUSTMENTS_FAIL,
  CLEAR_LEAVE_ADJUSTMENTS,
  ADD_LEAVE_ADJUSTMENT_REQUEST, ADD_LEAVE_ADJUSTMENT_SUCCESS, ADD_LEAVE_ADJUSTMENT_FAIL,
} from "../../constants/Leave/LeaveAdjustmentConstants";
import LeaveAdjustmentService from "../../service/Leave/LeaveAdjustmentService";
import { extractRows, toDateKey } from "../../service/Leave/leaveHelpers";

const errMsg = (error, fallback) =>
  error.response?.data?.Result || error.response?.data?.message || error.message || fallback;

const mapRow = (item, idx) => ({
  id: item.HLAJ_ADJUSTMENT_ID ?? `${idx}-${item.HLAJ_EMP_SERVICE_NO ?? ""}`,
  serviceNo: String(item.HLAJ_EMP_SERVICE_NO ?? ""),
  leaveTypeId: String(item.HLAJ_LEAVE_TYPE_ID ?? ""),
  date: toDateKey(item.HLAJ_ADJUSTMENT_DATE),
  days: Number(item.HLAJ_DAYS) || 0,
  adjType: item.HLAJ_ADJUSTMENT_TYPE ?? "",
  reason: item.HLAJ_REASON ?? "",
});

// Adjustments of one employee. Only called when an employee is picked.
export const fetchLeaveAdjustments = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LEAVE_ADJUSTMENTS_REQUEST });
    const body = await LeaveAdjustmentService.getByEmployee(serviceNo);
    const data = extractRows(body).map(mapRow);
    dispatch({ type: FETCH_LEAVE_ADJUSTMENTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_LEAVE_ADJUSTMENTS_FAIL, payload: errMsg(error, "Failed to fetch leave adjustments") });
  }
};

export const clearLeaveAdjustments = () => ({ type: CLEAR_LEAVE_ADJUSTMENTS });

export const addLeaveAdjustment = (data) => async (dispatch) => {
  try {
    dispatch({ type: ADD_LEAVE_ADJUSTMENT_REQUEST });
    await LeaveAdjustmentService.add(data);
    dispatch({ type: ADD_LEAVE_ADJUSTMENT_SUCCESS });
    return { ok: true, message: "Leave adjustment added successfully!" };
  } catch (error) {
    const message = errMsg(error, "Failed to add leave adjustment");
    dispatch({ type: ADD_LEAVE_ADJUSTMENT_FAIL, payload: message });
    return { ok: false, message };
  }
};